import { render, staticRenderFns } from "./CFileManagerAccess.vue?vue&type=template&id=fcc798da&scoped=true&"
import script from "./CFileManagerAccess.vue?vue&type=script&lang=ts&"
export * from "./CFileManagerAccess.vue?vue&type=script&lang=ts&"
import style0 from "./CFileManagerAccess.vue?vue&type=style&index=0&id=fcc798da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc798da",
  null
  
)

export default component.exports